import React, { useState } from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import Header from './components/Header7';
import Footer from './components/Footer7';
import ProductCard from './components/ProductCard';

const Shop = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [sortBy, setSortBy] = useState('featured');
    const [showFilters, setShowFilters] = useState(false);
    const [priceRange, setPriceRange] = useState([0, 10000]);

    const categories = ['ALL', 'NEW IN', 'WOMEN', 'MEN', 'SALE'];
    const sortOptions = [
        { value: 'featured', label: 'FEATURED' },
        { value: 'price-low', label: 'PRICE: LOW TO HIGH' },
        { value: 'price-high', label: 'PRICE: HIGH TO LOW' },
        { value: 'newest', label: 'NEWEST' },
    ];

    const products = [
        {
            id: 1,
            name: 'STATEMENT BLAZER',
            category: 'WOMEN',
            price: 5999,
            originalPrice: 7999,
            image: 'https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=600',
        },
        {
            id: 2,
            name: 'ESSENTIAL WHITE TEE',
            category: 'MEN',
            price: 1499,
            image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600',
        },
        {
            id: 3,
            name: 'LEATHER CROSSBODY',
            category: 'NEW IN',
            price: 3999,
            image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=600',
        },
        {
            id: 4,
            name: 'PLATFORM SNEAKERS',
            category: 'WOMEN',
            price: 4499,
            image: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=600',
        },
        {
            id: 5,
            name: 'OVERSIZED DENIM',
            category: 'MEN',
            price: 3499,
            image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=600',
        },
        {
            id: 6,
            name: 'STATEMENT SUNGLASSES',
            category: 'NEW IN',
            price: 2499,
            image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600',
        },
        {
            id: 7,
            name: 'SILK SLIP DRESS',
            category: 'WOMEN',
            price: 4999,
            originalPrice: 6499,
            image: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=600',
        },
        {
            id: 8,
            name: 'CHELSEA BOOTS',
            category: 'MEN',
            price: 6999,
            image: 'https://images.unsplash.com/photo-1638247025967-b4e38f787b76?w=600',
        },
        {
            id: 9,
            name: 'STRUCTURED BACKPACK',
            category: 'NEW IN',
            price: 2999,
            image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=600',
        },
        {
            id: 10,
            name: 'CASHMERE SCARF',
            category: 'SALE',
            price: 1999,
            originalPrice: 2999,
            image: 'https://images.unsplash.com/photo-1520903920243-00d872a2d1c9?w=600',
        },
        {
            id: 11,
            name: 'TAILORED TROUSERS',
            category: 'MEN',
            price: 3999,
            image: 'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=600',
        },
        {
            id: 12,
            name: 'STRUCTURED TOTE',
            category: 'WOMEN',
            price: 3499,
            image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600',
        },
    ];

    const filteredProducts = selectedCategory === 'all'
        ? products
        : products.filter(p => p.category.toLowerCase() === selectedCategory.toLowerCase());

    return (
        <div className="min-h-screen bg-white">
            <Header cartCount={3} />

            {/* Fullscreen Editorial Hero */}
            <div className="relative h-[60vh] lg:h-[80vh] bg-gray-900 flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-900/50"></div>
                <div className="relative z-10 text-center text-white px-6">
                    <h1 className="text-6xl lg:text-8xl xl:text-9xl font-bold uppercase tracking-tight mb-6">
                        FASHION
                        <br />
                        HUB
                    </h1>
                    <p className="text-lg lg:text-xl uppercase tracking-widest">
                        EXPLORE THE COLLECTION
                    </p>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
                {/* Controls - Editorial Style */}
                <div className="flex flex-col md:flex-row gap-6 mb-12 items-center justify-between">
                    {/* Search */}
                    <div className="w-full md:w-96">
                        <div className="relative">
                            <Search className="absolute left-0 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                            <input
                                type="text"
                                placeholder="SEARCH"
                                className="w-full pl-10 pr-4 py-4 border-b-2 border-gray-900 focus:outline-none bg-transparent text-gray-900 placeholder-gray-400 uppercase tracking-wider text-sm"
                            />
                        </div>
                    </div>

                    <div className="flex gap-4 items-center">
                        {/* Sort */}
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                            className="px-6 py-4 border-2 border-gray-900 focus:outline-none bg-white text-gray-900 uppercase tracking-wider text-sm font-bold rounded-none"
                        >
                            {sortOptions.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>

                        {/* Filter Toggle */}
                        <button
                            onClick={() => setShowFilters(!showFilters)}
                            className="px-8 py-4 bg-gray-900 text-white hover:bg-gray-800 transition-colors flex items-center gap-3 uppercase tracking-wider text-sm font-bold rounded-none"
                        >
                            <SlidersHorizontal size={18} />
                            <span>FILTER</span>
                        </button>
                    </div>
                </div>

                {/* Filters Panel */}
                {showFilters && (
                    <div className="bg-gray-100 border-2 border-gray-900 p-8 lg:p-12 mb-16">
                        <div className="flex justify-between items-center mb-10">
                            <h3 className="text-3xl font-bold uppercase tracking-tight">REFINE SELECTION</h3>
                            <button onClick={() => setShowFilters(false)} className="text-gray-600 hover:text-gray-900 transition-colors">
                                <X size={28} strokeWidth={2} />
                            </button>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                            {/* Price Range */}
                            <div>
                                <h4 className="font-bold mb-4 text-gray-900 uppercase tracking-wider text-sm">PRICE RANGE</h4>
                                <div className="space-y-3">
                                    <input
                                        type="range"
                                        min="0"
                                        max="10000"
                                        value={priceRange[1]}
                                        onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
                                        className="w-full"
                                    />
                                    <div className="flex justify-between text-sm text-gray-700 font-bold">
                                        <span>₹0</span>
                                        <span>₹{priceRange[1]}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Size */}
                            <div>
                                <h4 className="font-bold mb-4 text-gray-900 uppercase tracking-wider text-sm">SIZE</h4>
                                <div className="flex flex-wrap gap-3">
                                    {['XS', 'S', 'M', 'L', 'XL'].map(size => (
                                        <button
                                            key={size}
                                            className="w-16 h-16 border-2 border-gray-900 hover:bg-gray-900 hover:text-white transition-colors font-bold rounded-none"
                                        >
                                            {size}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Color */}
                            <div>
                                <h4 className="font-bold mb-4 text-gray-900 uppercase tracking-wider text-sm">COLOR</h4>
                                <div className="flex flex-wrap gap-3">
                                    {[
                                        { name: 'BLACK', value: '#000000' },
                                        { name: 'WHITE', value: '#FFFFFF' },
                                        { name: 'GRAY', value: '#808080' },
                                        { name: 'BEIGE', value: '#D4C5B9' }
                                    ].map(color => (
                                        <button
                                            key={color.value}
                                            className="w-16 h-16 border-2 border-gray-900 hover:border-gray-600 transition-colors rounded-none"
                                            style={{ backgroundColor: color.value }}
                                            title={color.name}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Category Navigation - Bold */}
                <div className="flex flex-wrap justify-center gap-6 mb-16 border-y-2 border-gray-900 py-8">
                    {categories.map(category => (
                        <button
                            key={category}
                            onClick={() => setSelectedCategory(category.toLowerCase())}
                            className={`px-8 py-3 text-sm font-bold tracking-widest transition-all uppercase rounded-none ${
                                selectedCategory === category.toLowerCase()
                                    ? 'bg-gray-900 text-white'
                                    : 'bg-white text-gray-900 border-2 border-gray-900 hover:bg-gray-900 hover:text-white'
                            }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Products Grid - Editorial Layout */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-10 mb-20">
                    {filteredProducts.map(product => (
                        <ProductCard key={product.id} product={product} />
                    ))}
                </div>

                {/* Load More - Bold Statement */}
                <div className="text-center border-t-2 border-gray-900 pt-12">
                    <button className="px-16 py-5 bg-gray-900 text-white hover:bg-gray-800 transition-colors font-bold text-sm tracking-widest uppercase rounded-none">
                        LOAD MORE
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Shop;
